import { get, post } from "./base";

const CreditServ = {
    // Get credit balance
    getBalance: () => get("/credits/balance"),

    // Get credit transactions
    getTransactions: (params) => get("/credits/transactions", { params }),

    // Get credit statistics
    getStats: () => get("/credits/stats"),

    // Admin: Add credits to user
    adminAddCredits: (payload) => post("/credits/admin/add", payload),
};

export default CreditServ;
